import { render, staticRenderFns } from "./NewOnsiteTemplate.vue?vue&type=template&id=c0902a68"
import script from "./NewOnsiteTemplate.vue?vue&type=script&lang=js"
export * from "./NewOnsiteTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports